import { useEffect, useMemo, useState } from 'react';
import { Table } from 'antd';
import { PageHeader } from 'components';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import useShoppingCenter from '../useShoppingCenter';
import styles from './style.module.scss';

const RIMAIL_API_URL = process.env.REACT_APP_RIMAIL_API_URL;

const SourcePages = () => {
  const { sourceId } = useParams();
  const { singleShop } = useShoppingCenter(false);
  const [loading, setLoading] = useState(false);
  const [pages, setPages] = useState([]);
  const [sourceName, setSourceName] = useState('');

  useEffect(() => {
    const fetchSourcePages = async () => {
      if (
        !singleShop?.rimail_agent_id ||
        !singleShop?.rimail_token ||
        !sourceId
      ) {
        setPages([]);
        return;
      }

      setLoading(true);
      try {
        const response = await axios.get(
          `${RIMAIL_API_URL}/chatgpt_agents/${singleShop.rimail_agent_id}/chatgpt_agent_sources/${sourceId}`,
          {
            headers: {
              'auth-token': singleShop.rimail_token,
            },
          },
        );

        const source =
          response?.data?.chatgpt_agent_source || response?.data || {};
        const nextPages = source?.chatgpt_agent_pages || [];
        setSourceName(source?.source_name || '');
        setPages(Array.isArray(nextPages) ? nextPages : []);
      } catch (e) {
        setSourceName('');
        setPages([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSourcePages();
  }, [singleShop?.rimail_agent_id, singleShop?.rimail_token, sourceId]);

  const columns = useMemo(
    () => [
      {
        title: 'Titolo pagina',
        dataIndex: 'page_title',
        key: 'page_title',
      },
      {
        title: 'URL sorgente',
        dataIndex: 'source_url',
        key: 'source_url',
      },
    ],
    [],
  );

  return (
    <div>
      <PageHeader
        title={
          sourceName
            ? `Pagine sorgente — ${sourceName}`
            : 'Pagine sorgente'
        }
      />
      <div className={styles.content}>
        <Table
          columns={columns}
          dataSource={pages}
          rowKey='id'
          loading={loading}
          pagination={false}
        />
      </div>
    </div>
  );
};

export default SourcePages;
